import React from 'react';
import PropTypes from 'prop-types';

const Tools = ({ backupData, activeTab }) => {
  return (<section className={ activeTab === 'tools' ? 'tab-content is-enabled' : 'tab-content' }>
    <a onClick={ backupData }>Download data</a>
    <p>Click the link above to download the site database in JSON format. </p>
  </section>)
};

Tools.propTypes = {
  backupData: PropTypes.func,
  activeTab: PropTypes.string
};

export default Tools;



// WEBPACK FOOTER //
// ./src/containers/admin/Tools.js